import { render, staticRenderFns } from "./VDealTransitions.vue?vue&type=template&id=e8b1e0f8"
import script from "./VDealTransitions.vue?vue&type=script&lang=js"
export * from "./VDealTransitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports